import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'

const useAdBackUrl = adId => {
  const {domain} = useContext(Context)
  const [hrefBack, setHrefBack] = useState(undefined)

  useEffect(() => {
    let isCancelled = false

    domain
      .get('get_navigation_links_ads_use_case')
      .execute({id: adId})
      .then(([error, response]) => {
        if (error || isCancelled) return
        setHrefBack(response.backUrl)
      })

    return () => {
      isCancelled = true
    }
  }, [domain, adId])

  return hrefBack
}

export default useAdBackUrl
